import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';

const ErrorPhase = ({ searchError, resetAll }) => (
  <motion.div
    key="error"
    className="report-stage final-report"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <div className="report-header">
      <AlertTriangle size={40} className="check-icon score-critical" />
      <h3>Scan failed</h3>
    </div>

    <div className="report-summary reveal-block is-visible">
      <p className="report-block-title"><strong>What happened</strong></p>
      <p>{searchError || 'Something went wrong. Please try again.'}</p>
    </div>

    <button className="btn-try-again" type="button" onClick={resetAll}>
      Try again
    </button>
  </motion.div>
);

export default ErrorPhase;
